import { render, staticRenderFns } from "./PopupTooltip.vue?vue&type=template&id=5fde700a&scoped=true"
import script from "./PopupTooltip.vue?vue&type=script&lang=js"
export * from "./PopupTooltip.vue?vue&type=script&lang=js"
import style0 from "./PopupTooltip.vue?vue&type=style&index=0&id=5fde700a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fde700a",
  null
  
)

export default component.exports